import { createFileRoute } from "@tanstack/react-router";
import { EnergiPage, energiHead } from "@/pages/EnergiPage";

export const Route = createFileRoute("/brancher/energi-infrastruktur")({
  head: () => energiHead("da"),
  component: () => <EnergiPage locale="da" />,
});
